export const nationalityCodes = [
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11",
	"12",
	"13",
	"14",
	"15",
	"16",
	"17",
	"18",
	"19",
	"20",
	"21",
	"22",
	"23",
	"24",
	"25",
	"26",
	"27",
	"28",
	"29",
	"30",
	"31",
	"32",
	"33",
	"34",
	"35",
	"36",
	"37",
	"38",
	"39",
	"40",
	"41",
	"42",
	"43",
	"44",
	"45",
	"46",
	"47",
	"48",
	"49",
	"50",
	"51",
	"52",
	"53",
	"54",
	"55",
	"56",
	"57",
	"58",
	"59",
	"60",
	"61",
	"62",
	"63",
	"64",
	"65",
	"66",
	"67",
	"68",
	"69",
	"70",
	"71",
	"72",
	"73",
	"74",
	"75",
	"76",
	"77",
	"78",
	"79",
	"80",
	"81",
	"82",
	"83",
	"84",
	"85",
	"86",
	"87",
	"88",
	"89",
	"90",
	"91",
	"92",
	"93",
	"94",
	"95",
	"96",
	"97",
	"98",
	"99",
	"100",
	"101",
	"102",
	"103",
	"104",
	"105",
	"106",
	"107",
	"108",
	"109",
	"110",
	"111",
	"112",
	"113",
	"114",
	"115",
	"116",
	"117",
	"118",
	"119",
	"120",
	"121",
	"122",
	"123",
	"124",
	"125",
	"126",
	"127",
	"128",
	"129",
	"130",
	"131",
	"132",
	"133",
	"134",
	"135",
	"136",
	"137",
	"138",
	"139",
	"140",
	"141",
	"142",
	"143",
	"144",
	"145",
	"146",
	"147",
	"148",
	"149",
	"150",
	"151",
	"152",
	"153",
	"154",
	"155",
	"156",
	"157",
	"158",
	"159",
	"160",
	"161",
	"162",
	"163",
	"164",
	"165",
	"166",
	"167",
	"168",
	"169",
	"170",
	"171",
	"172",
	"173",
	"174",
	"175",
	"176",
	"177",
	"178",
	"179",
	"180",
	"181",
	"182",
	"183",
	"184",
	"185",
	"186",
	"187",
	"188",
	"189",
	"190",
	"191",
	"192",
	"193",
	"194",
	"195",
	"196",
	"197",
	"198",
	"199",
	"200",
	"201",
	"202",
	"203",
	"204",
	"205",
	"206",
	"207",
	"208",
	"209",
	"210",
	"211",
	"212",
	"213",
	"214",
	"215",
	"216",
	"217",
	"218",
	"219",
	"220",
	"221",
	"222",
	"223",
	"224",
	"225",
	"226",
	"227",
	"228",
	"229",
	"230",
	"231",
	"232",
	"233",
	"234",
	"235",
	"236",
	"237",
	"238",
	"239",
	"240",
	"241",
	"242",
	"243",
	"244",
	"245",
];

export const ethnicityCodes = [
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11",
	"12",
	"13",
	"14",
	"15",
	"16",
	"17",
	"18",
	"19",
	"20",
	"21",
	"22",
	"23",
	"24",
	"25",
	"26",
	"27",
	"28",
	"29",
	"30",
	"31",
	"32",
	"33",
	"34",
	"35",
	"36",
	"37",
	"38",
	"39",
	"40",
	"41",
	"42",
	"43",
	"44",
	"45",
	"46",
	"47",
	"48",
	"49",
	"50",
	"51",
	"52",
	"53",
	"54",
	"56",
];

export const majorCodes = [
	"714",
	"71401",
	"7140101",
	"7140114",
	"71402",
	"7140201",
	"7140202",
	"7140203",
	"7140204",
	"7140205",
	"7140206",
	"7140207",
	"7140208",
	"7140209",
	"7140210",
	"7140211",
	"7140212",
	"7140213",
	"7140214",
	"7140215",
	"7140217",
	"7140218",
	"7140219",
	"7140221",
	"7140222",
	"7140223",
	"7140224",
	"7140225",
	"7140226",
	"7140227",
	"7140228",
	"7140229",
	"7140230",
	"7140231",
	"7140232",
	"7140233",
	"7140234",
	"7140235",
	"7140236",
	"7140237",
	"7140245",
	"7140246",
	"7140247",
	"7140248",
	"71490",
	"721",
	"72101",
	"7210101",
	"7210103",
	"7210104",
	"7210105",
	"7210107",
	"7210110",
	"72102",
	"7210201",
	"7210203",
	"7210204",
	"7210205",
	"7210207",
	"7210208",
	"7210209",
	"7210210",
	"7210221",
	"7210225",
	"7210226",
	"7210227",
	"7210231",
	"7210233",
	"7210234",
	"7210235",
	"7210236",
	"7210241",
	"7210242",
	"7210243",
	"7210244",
	"72103",
	"7210301",
	"7210302",
	"7210303",
	"72104",
	"7210402",
	"7210403",
	"7210404",
	"7210406",
	"72190",
	"722",
	"72201",
	"7220101",
	"7220104",
	"7220105",
	"7220106",
	"7220107",
	"7220108",
	"7220110",
	"7220112",
	"72202",
	"7220201",
	"7220202",
	"7220203",
	"7220204",
	"7220205",
	"7220206",
	"7220207",
	"7220208",
	"7220209",
	"7220210",
	"7220211",
	"72290",
	"7229001",
	"729008",
	"7229009",
	"7229010",
	"7229020",
	"7229030",
	"7229040",
	"7229042",
	"7229045",
	"731",
	"73101",
	"7310101",
	"7310102",
	"7310104",
	"7310105",
	"7310106",
	"7310107",
	"7310108",
	"73102",
	"7310201",
	"7310202",
	"7310205",
	"7310206",
	"73103",
	"7310301",
	"7310302",
	"73104",
	"7310401",
	"7310403",
	"73105",
	"7310501",
	"73106",
	"7310601",
	"7310602",
	"7310607",
	"7310608",
	"7310612",
	"7310613",
	"7310614",
	"7310620",
	"7310630",
	"73190",
	"732",
	"73201",
	"7320101",
	"7320104",
	"7320105",
	"7320106",
	"7320107",
	"7320108",
	"73202",
	"7320201",
	"7320205",
	"73203",
	"7320303",
	"7320305",
	"73204",
	"7320401",
	"7320402",
	"73290",
	"734",
	"73401",
	"7340101",
	"7340115",
	"7340116",
	"7340120",
	"7340121",
	"7340122",
	"7340123",
	"73402",
	"7340201",
	"7340204",
	"73403",
	"7340301",
	"7340302",
	"73404",
	"7340401",
	"7340403",
	"7340404",
	"7340405",
	"7340406",
	"7340408",
	"7340409",
	"73490",
	"738",
	"73801",
	"7380101",
	"7380102",
	"7380103",
	"7380104",
	"7380107",
	"7380108",
	"73890",
	"742",
	"74201",
	"7420101",
	"74202",
	"7420201",
	"7420202",
	"7420203",
	"74290",
	"744",
	"74401",
	"7440101",
	"7440102",
	"7440106",
	"7440110",
	"7440112",
	"7440122",
	"74402",
	"7440201",
	"7440212",
	"7440217",
	"7440221",
	"7440224",
	"7440228",
	"74403",
	"7440301",
	"74490",
	"746",
	"74601",
	"7460101",
	"7460107",
	"7460112",
	"7460115",
	"7460117",
	"74602",
	"7460201",
	"74690",
	"748",
	"74801",
	"7480101",
	"7480102",
	"7480103",
	"7480104",
	"7480106",
	"7480108",
	"74802",
	"7480201",
	"7480202",
	"74890",
	"751",
	"75101",
	"7510101",
	"7510102",
	"7510103",
	"7510104",
	"7510105",
	"75102",
	"7510201",
	"7510202",
	"7510203",
	"7510205",
	"7510206",
	"7510207",
	"7510211",
	"75103",
	"7510301",
	"7510302",
	"7510303",
	"75104",
	"7510401",
	"7510402",
	"7510406",
	"7510407",
	"75106",
	"7510601",
	"7510604",
	"7510605",
	"75107",
	"7510701",
	"75108",
	"7510801",
	"75190",
	"752",
	"75201",
	"7520101",
	"7520103",
	"7520114",
	"7520115",
	"7520116",
	"7520117",
	"7520118",
	"7520120",
	"7520121",
	"7520122",
	"7520130",
	"7520137",
	"75202",
	"7520201",
	"7520204",
	"7520205",
	"7520207",
	"7520212",
	"7520216",
	"75203",
	"7520301",
	"7520309",
	"7520310",
	"7520312",
	"7520320",
	"75204",
	"7520401",
	"7520402",
	"75205",
	"7520501",
	"7520502",
	"7520503",
	"75206",
	"7520601",
	"7520602",
	"7520604",
	"7520607",
	"75290",
	"7529001",
	"754",
	"75401",
	"7540101",
	"7540102",
	"7540104",
	"7540105",
	"7540106",
	"75402",
	"7540202",
	"7540203",
	"7540204",
	"7540206",
	"75490",
	"7549001",
	"758",
	"75801",
	"7580101",
	"7580102",
	"7580103",
	"7580104",
	"7580105",
	"7580106",
	"7580108",
	"7580111",
	"7580112",
	"75802",
	"7580201",
	"7580202",
	"7580203",
	"7580205",
	"7580210",
	"7580211",
	"7580212",
	"7580213",
	"75803",
	"7580301",
	"7580302",
	"75890",
	"762",
	"76201",
	"7620101",
	"7620102",
	"7620103",
	"7620105",
	"7620109",
	"7620110",
	"7620112",
	"7620113",
	"7620114",
	"7620115",
	"7620116",
	"76202",
	"7620201",
	"7620202",
	"7620205",
	"7620211",
	"76203",
	"7620301",
	"7620302",
	"7620303",
	"7620304",
	"7620305",
	"76290",
	"764",
	"76401",
	"7640101",
	"76490",
	"772",
	"77201",
	"7720101",
	"7720110",
	"7720115",
	"77202",
	"7720201",
	"7720203",
	"77203",
	"7720301",
	"7720302",
	"77204",
	"7720401",
	"77205",
	"7720501",
	"7720502",
	"77206",
	"7720601",
	"7720602",
	"7720603",
	"77207",
	"7720701",
	"77208",
	"7720801",
	"7720802",
	"77290",
	"7729001",
	"776",
	"77601",
	"7760101",
	"7760102",
	"8760103",
	"77690",
	"781",
	"78101",
	"7810101",
	"7810103",
	"78102",
	"7810201",
	"7810202",
	"78103",
	"7810301",
	"78105",
	"7810501",
	"78190",
	"784",
	"78401",
	"7840101",
	"7840102",
	"7840104",
	"7840106",
	"78490",
	"785",
	"78501",
	"7850101",
	"7850102",
	"7850103",
	"78502",
	"7850201",
	"78590",
	"786",
	"78601",
	"7860101",
	"7860102",
	"7860104",
	"7860108",
	"7860109",
	"7860110",
	"7860111",
	"7860112",
	"7860113",
	"7860116",
	"7860117",
	"78602",
	"7860201",
	"7860202",
	"7860203",
	"7860204",
	"7860205",
	"7860206",
	"7860207",
	"7860214",
	"7860217",
	"7860218",
	// "7860220",
	"7860222",
	"7860220",
	"7860226",
	"7860227",
	"7860228",
	"7860229",
	"7860231",
	"7860232",
	"7860233",
	"78690",
	"790",
];

export const majorCodesWithName = [
	{ code: "714", name: "Khoa học giáo dục và đào tạo giáo viên" },
	{ code: "71401", name: "Khoa học giáo dục" },
	{ code: "7140101", name: "Giáo dục học" },
	{ code: "7140114", name: "Quản lý giáo dục" },
	{ code: "71402", name: "Đào tạo giáo viên" },
	{ code: "7140201", name: "Giáo dục Mầm non" },
	{ code: "7140202", name: "Giáo dục Tiểu học" },
	{ code: "7140203", name: "Giáo dục Đặc biệt" },
	{ code: "7140204", name: "Giáo dục Công dân" },
	{ code: "7140205", name: "Giáo dục Chính trị" },
	{ code: "7140206", name: "Giáo dục Thể chất" },
	{ code: "7140207", name: "Huấn luyện thể thao" },
	{ code: "7140208", name: "Giáo dục Quốc phòng - An ninh" },
	{ code: "7140209", name: "Sư phạm Toán học" },
	{ code: "7140210", name: "Sư phạm Tin học" },
	{ code: "7140211", name: "Sư phạm Vật lý" },
	{ code: "7140212", name: "Sư phạm Hoá học" },
	{ code: "7140213", name: "Sư phạm Sinh học" },
	{ code: "7140214", name: "Sư phạm Kỹ thuật công nghiệp" },
	{ code: "7140215", name: "Sư phạm Kỹ thuật nông nghiệp" },
	{ code: "7140217", name: "Sư phạm Ngữ văn" },
	{ code: "7140218", name: "Sư phạm Lịch sử" },
	{ code: "7140219", name: "Sư phạm Địa lý" },
	{ code: "7140221", name: "Sư phạm Âm nhạc" },
	{ code: "7140222", name: "Sư phạm Mỹ thuật" },
	{ code: "7140223", name: "Sư phạm Tiếng Bana" },
	{ code: "7140224", name: "Sư phạm Tiếng Êđê" },
	{ code: "7140225", name: "Sư phạm Tiếng Jrai" },
	{ code: "7140226", name: "Sư phạm Tiếng Khmer" },
	{ code: "7140227", name: "Sư phạm Tiếng H'mong" },
	{ code: "7140228", name: "Sư phạm Tiếng Chăm" },
	{ code: "7140229", name: "Sư phạm Tiếng M'nông" },
	{ code: "7140230", name: "Sư phạm Tiếng Xê đăng" },
	{ code: "7140231", name: "Sư phạm Tiếng Anh" },
	{ code: "7140232", name: "Sư phạm Tiếng Nga" },
	{ code: "7140233", name: "Sư phạm Tiếng Pháp" },
	{ code: "7140234", name: "Sư phạm Tiếng Trung Quốc" },
	{ code: "7140235", name: "Sư phạm Tiếng Đức" },
	{ code: "7140236", name: "Sư phạm Tiếng Nhật" },
	{ code: "7140237", name: "Sư phạm Tiếng Hàn Quốc" },
	{ code: "7140245", name: "Sư phạm nghệ thuật" },
	{ code: "7140246", name: "Sư phạm công nghệ" },
	{ code: "7140247", name: "Sư phạm khoa học tự nhiên" },
	{ code: "7140248", name: "Giáo dục pháp luật" },
	{ code: "71490", name: "Khác" },
	{ code: "721", name: "Nghệ thuật" },
	{ code: "72101", name: "Mỹ thuật" },
	{ code: "7210101", name: "Lý luận, lịch sử và phê bình mỹ thuật" },
	{ code: "7210103", name: "Hội hoạ" },
	{ code: "7210104", name: "Đồ hoạ" },
	{ code: "7210105", name: "Điêu khắc" },
	{ code: "7210107", name: "Gốm" },
	{ code: "7210110", name: "Mỹ thuật đô thị" },
	{ code: "72102", name: "Nghệ thuật trình diễn" },
	{ code: "7210201", name: "Âm nhạc học" },
	{ code: "7210203", name: "Sáng tác âm nhạc" },
	{ code: "7210204", name: "Chỉ huy âm nhạc" },
	{ code: "7210205", name: "Thanh nhạc" },
	{ code: "7210207", name: "Biểu diễn nhạc cụ phương tây" },
	{ code: "7210208", name: "Piano" },
	{ code: "7210209", name: "Nhạc Jazz" },
	{ code: "7210210", name: "Biểu diễn nhạc cụ truyền thống" },
	{ code: "7210221", name: "Lý luận, lịch sử và phê bình sân khấu" },
	{ code: "7210225", name: "Biên kịch sân khấu" },
	{ code: "7210226", name: "Diễn viên sân khấu kịch hát" },
	{ code: "7210227", name: "Đạo diễn sân khấu" },
	{ code: "7210231", name: "Lý luận, lịch sử và phê bình điện ảnh, truyền hình" },
	{ code: "7210233", name: "Biên kịch điện ảnh, truyền hình" },
	{ code: "7210234", name: "Diễn viên kịch, điện ảnh - truyền hình" },
	{ code: "7210235", name: "Đạo diễn điện ảnh, truyền hình" },
	{ code: "7210236", name: "Quay phim" },
	{ code: "7210241", name: "Lý luận, lịch sử và phê bình múa" },
	{ code: "7210242", name: "Diễn viên múa" },
	{ code: "7210243", name: "Biên đạo múa" },
	{ code: "7210244", name: "Huấn luyện múa" },
	{ code: "72103", name: "Nghệ thuật nghe nhìn" },
	{ code: "7210301", name: "Nhiếp ảnh" },
	{ code: "7210302", name: "Công nghệ điện ảnh, truyền hình" },
	{ code: "7210303", name: "Thiết kế âm thanh, ánh sáng" },
	{ code: "72104", name: "Mỹ thuật ứng dụng" },
	{ code: "7210402", name: "Thiết kế công nghiệp" },
	{ code: "7210403", name: "Thiết kế đồ họa" },
	{ code: "7210404", name: "Thiết kế thời trang" },
	{ code: "7210406", name: "Thiết kế mỹ thuật sân khấu, điện ảnh" },
	{ code: "72190", name: "Khác" },
	{ code: "722", name: "Nhân văn" },
	{ code: "72201", name: "Ngôn ngữ, văn học và văn hoá Việt Nam" },
	{ code: "7220101", name: "Tiếng Việt và văn hoá ViệtNam" },
	{ code: "7220104", name: "Hán Nôm" },
	{ code: "7220105", name: "Ngôn ngữ Jrai" },
	{ code: "7220106", name: "Ngôn ngữ Khmer" },
	{ code: "7220107", name: "Ngôn ngữ H'mong" },
	{ code: "7220108", name: "Ngôn ngữ Chăm" },
	{ code: "7220110", name: "Sáng tác văn học" },
	{ code: "7220112", name: "Văn hoá các dân tộc thiểu số ViệtNam" },
	{ code: "72202", name: "Ngôn ngữ, văn học và văn hoá nước ngoài" },
	{ code: "7220201", name: "Ngôn ngữ Anh" },
	{ code: "7220202", name: "Ngôn ngữ Nga" },
	{ code: "7220203", name: "Ngôn ngữ Pháp" },
	{ code: "7220204", name: "Ngôn ngữ Trung Quốc" },
	{ code: "7220205", name: "Ngôn ngữ Đức" },
	{ code: "7220206", name: "Ngôn ngữ Tây Ban Nha" },
	{ code: "7220207", name: "Ngôn ngữ Bồ Đào Nha" },
	{ code: "7220208", name: "Ngôn ngữ Italia" },
	{ code: "7220209", name: "Ngôn ngữ Nhật" },
	{ code: "7220210", name: "Ngôn ngữ Hàn Quốc" },
	{ code: "7220211", name: "Ngôn ngữ Ảrập" },
	{ code: "72290", name: "Khác" },
	{ code: "7229001", name: "Triết học" },
	{ code: "729008", name: "Chủ nghĩa xã hội khoa học" },
	{ code: "7229009", name: "Tôn giáo học" },
	{ code: "7229010", name: "Lịch sử" },
	{ code: "7229020", name: "Ngôn ngữ học" },
	{ code: "7229030", name: "Văn học" },
	{ code: "7229040", name: "Văn hoá học" },
	{ code: "7229042", name: "Quản lý văn hoá" },
	{ code: "7229045", name: "Gia đình học" },
	{ code: "731", name: "Khoa học xã hội và hành vi" },
	{ code: "73101", name: "Kinh tế học" },
	{ code: "7310101", name: "Kinh tế" },
	{ code: "7310102", name: "Kinh tế chính trị" },
	{ code: "7310104", name: "Kinh tế đầu tư" },
	{ code: "7310105", name: "Kinh tế phát triển" },
	{ code: "7310106", name: "Kinh tế quốc tế" },
	{ code: "7310107", name: "Thống kê kinh tế" },
	{ code: "7310108", name: "Toán kinh tế" },
	{ code: "73102", name: "Khoa học chính trị" },
	{ code: "7310201", name: "Chính trị học" },
	{ code: "7310202", name: "Xây dựng Đảng và chính quyền nhà nước" },
	{ code: "7310205", name: "Quản lý nhà nước" },
	{ code: "7310206", name: "Quan hệ quốc tế" },
	{ code: "73103", name: "Xã hội học và Nhân học" },
	{ code: "7310301", name: "Xã hội học" },
	{ code: "7310302", name: "Nhân học" },
	{ code: "73104", name: "Tâm lý học" },
	{ code: "7310401", name: "Tâm lý học" },
	{ code: "7310403", name: "Tâm lý học giáo dục" },
	{ code: "73105", name: "Địa lý học" },
	{ code: "7310501", name: "Địa lý học" },
	{ code: "73106", name: "Khu vực học" },
	{ code: "7310601", name: "Quốc tế học" },
	{ code: "7310602", name: "Châu Á học" },
	{ code: "7310607", name: "Thái Bình Dương học" },
	{ code: "7310608", name: "Đông phương học" },
	{ code: "7310612", name: "Trung Quốc học" },
	{ code: "7310613", name: "Nhật Bản học" },
	{ code: "7310614", name: "Hàn Quốc học" },
	{ code: "7310620", name: "Đông Nam Á học" },
	{ code: "7310630", name: "ViệtNamhọc" },
	{ code: "73190", name: "Khác" },
	{ code: "732", name: "Báo chí và thông tin" },
	{ code: "73201", name: "Báo chí và truyền thông" },
	{ code: "7320101", name: "Báo chí" },
	{ code: "7320104", name: "Truyền thông đa phương tiện" },
	{ code: "7320105", name: "Truyền thông đại chúng" },
	{ code: "7320106", name: "Công nghệ truyền thông" },
	{ code: "7320107", name: "Truyền thông quốc tế" },
	{ code: "7320108", name: "Quan hệ công chúng" },
	{ code: "73202", name: "Thông tin - Thư viện" },
	{ code: "7320201", name: "Thông tin - thư viện" },
	{ code: "7320205", name: "Quản lý thông tin" },
	{ code: "73203", name: "Văn thư - Lưu trữ - Bảo tàng" },
	{ code: "7320303", name: "Lưu trữ học" },
	{ code: "7320305", name: "Bảo tàng học" },
	{ code: "73204", name: "Xuất bản - Phát hành" },
	{ code: "7320401", name: "Xuất bản" },
	{ code: "7320402", name: "Kinh doanh xuất bản phẩm" },
	{ code: "73290", name: "Khác" },
	{ code: "734", name: "Kinh doanh và quản lý" },
	{ code: "73401", name: "Kinh doanh" },
	{ code: "7340101", name: "Quản trị kinh doanh" },
	{ code: "7340115", name: "Marketing" },
	{ code: "7340116", name: "Bất động sản" },
	{ code: "7340120", name: "Kinh doanh quốc tế" },
	{ code: "7340121", name: "Kinh doanh thương mại" },
	{ code: "7340122", name: "Thương mại điện tử" },
	{ code: "7340123", name: "Kinh doanh thời trang và dệt may" },
	{ code: "73402", name: "Tài chính - Ngân hàng - Bảo hiểm" },
	{ code: "7340201", name: "Tài chính - Ngân hàng" },
	{ code: "7340204", name: "Bảo hiểm" },
	{ code: "73403", name: "Kế toán - Kiểm toán" },
	{ code: "7340301", name: "Kế toán" },
	{ code: "7340302", name: "Kiểm toán" },
	{ code: "73404", name: "Quản trị - Quản lý" },
	{ code: "7340401", name: "Khoa học quản lý" },
	{ code: "7340403", name: "Quản lý công" },
	{ code: "7340404", name: "Quản trị nhân lực" },
	{ code: "7340405", name: "Hệ thống thông tin quản lý" },
	{ code: "7340406", name: "Quản trị văn phòng" },
	{ code: "7340408", name: "Quan hệ lao động" },
	{ code: "7340409", name: "Quản lý dựán" },
	{ code: "73490", name: "Khác" },
	{ code: "738", name: "Pháp luật" },
	{ code: "73801", name: "Luật" },
	{ code: "7380101", name: "Luật" },
	{ code: "7380102", name: "Luật hiến pháp và luật hành chính" },
	{ code: "7380103", name: "Luật dân sự và tố tụng dân sự" },
	{ code: "7380104", name: "Luật hình sự và tố tụng hình sự" },
	{ code: "7380107", name: "Luật kinh tế" },
	{ code: "7380108", name: "Luật quốc tế" },
	{ code: "73890", name: "Khác" },
	{ code: "742", name: "Khoa học sự sống" },
	{ code: "74201", name: "Sinh học" },
	{ code: "7420101", name: "Sinh học" },
	{ code: "74202", name: "Sinh học ứng dụng" },
	{ code: "7420201", name: "Công nghệ sinh học" },
	{ code: "7420202", name: "Kỹ thuật sinh học" },
	{ code: "7420203", name: "Sinh học ứng dụng" },
	{ code: "74290", name: "Khác" },
	{ code: "744", name: "Khoa học tự nhiên" },
	{ code: "74401", name: "Khoa học vật chất" },
	{ code: "7440101", name: "Thiên văn học" },
	{ code: "7440102", name: "Vật lý học" },
	{ code: "7440106", name: "Vật lý nguyên tử và hạt nhân" },
	{ code: "7440110", name: "Cơ học" },
	{ code: "7440112", name: "Hoá học" },
	{ code: "7440122", name: "Khoa học vật liệu" },
	{ code: "74402", name: "Khoa học trái đất" },
	{ code: "7440201", name: "Địa chất học" },
	{ code: "7440212", name: "Bản đồ học" },
	{ code: "7440217", name: "Địa lý tự nhiênkỹ thuật" },
	{ code: "7440221", name: "Khí tượng và khí hậu học" },
	{ code: "7440224", name: "Thuỷ văn học" },
	{ code: "7440228", name: "Hải dương học" },
	{ code: "74403", name: "Khoa học môi trường" },
	{ code: "7440301", name: "Khoa học môi trường" },
	{ code: "74490", name: "Khác" },
	{ code: "746", name: "Toán và thống kê" },
	{ code: "74601", name: "Toán học" },
	{ code: "7460101", name: "Toán học" },
	{ code: "7460107", name: "Khoa học tính toán" },
	{ code: "7460112", name: "Toán ứng dụng" },
	{ code: "7460115", name: "Toán cơ" },
	{ code: "7460117", name: "Toán tin" },
	{ code: "74602", name: "Thống kê" },
	{ code: "7460201", name: "Thống kê" },
	{ code: "74690", name: "Khác" },
	{ code: "748", name: "Máy tính và công nghệ thông tin" },
	{ code: "74801", name: "Máy tính" },
	{ code: "7480101", name: "Khoa học máy tính" },
	{ code: "7480102", name: "Mạng máy tính và truyền thông dữ liệu" },
	{ code: "7480103", name: "Kỹ thuật phần mềm" },
	{ code: "7480104", name: "Hệ thống thông tin" },
	{ code: "7480106", name: "Kỹ thuật máy tính" },
	{ code: "7480108", name: "Công nghệ kỹ thuật máy tính" },
	{ code: "74802", name: "Công nghệ thông tin" },
	{ code: "7480201", name: "Công nghệ thông tin" },
	{ code: "7480202", name: "An toàn thông tin" },
	{ code: "74890", name: "Khác" },
	{ code: "751", name: "Công nghệ kỹ thuật" },
	{ code: "75101", name: "Công nghệ kỹ thuật kiến trúc và công trình xây dựng" },
	{ code: "7510101", name: "Công nghệ kỹ thuật kiến trúc" },
	{ code: "7510102", name: "Công nghệ kỹ thuật công trình xây dựng" },
	{ code: "7510103", name: "Công nghệ kỹ thuật xây dựng" },
	{ code: "7510104", name: "Công nghệ kỹ thuật giao thông" },
	{ code: "7510105", name: "Công nghệ kỹ thuật vật liệu xây dựng" },
	{ code: "75102", name: "Công nghệ kỹ thuật cơ khí" },
	{ code: "7510201", name: "Công nghệ kỹ thuật cơ khí" },
	{ code: "7510202", name: "Công nghệ chế tạo máy" },
	{ code: "7510203", name: "Công nghệ kỹ thuật cơ điện tử" },
	{ code: "7510205", name: "Công nghệ kỹ thuật ô tô" },
	{ code: "7510206", name: "Công nghệ kỹ thuật nhiệt" },
	{ code: "7510207", name: "Công nghệ kỹ thuật tàu thủy" },
	{ code: "7510211", name: "Bảo dưỡng công nghiệp" },
	{ code: "75103", name: "Công nghệ kỹ thuật điện, điện tử và viễn thông" },
	{ code: "7510301", name: "Công nghệ kỹ thuật điện, điện tử" },
	{ code: "7510302", name: "Công nghệ kỹ thuật điện tử - viễn thông" },
	{ code: "7510303", name: "Công nghệ kỹ thuật điều khiển và tự động hóa" },
	{ code: "75104", name: "Công nghệ hoá học, vật liệu, luyện kim và môi trường" },
	{ code: "7510401", name: "Công nghệ kỹ thuật hoá học" },
	{ code: "7510402", name: "Công nghệ vật liệu" },
	{ code: "7510406", name: "Công nghệ kỹ thuật môi trường" },
	{ code: "7510407", name: "Công nghệ kỹ thuật hạt nhân" },
	{ code: "75106", name: "Quản lý công nghiệp" },
	{ code: "7510601", name: "Quản lý công nghiệp" },
	{ code: "7510604", name: "Kinh tế công nghiệp" },
	{ code: "7510605", name: "Logistics và Quản lý chuỗi cung ứng" },
	{ code: "75107", name: "Công nghệ dầu khí và khai thác" },
	{ code: "7510701", name: "Công nghệ dầu khí và khai thác dầu" },
	{ code: "75108", name: "Công nghệ kỹ thuật in" },
	{ code: "7510801", name: "Công nghệ kỹ thuật in" },
	{ code: "75190", name: "Khác" },
	{ code: "752", name: "Kỹ thuật" },
	{ code: "75201", name: "Kỹ thuật cơ khí và cơ kỹ thuật" },
	{ code: "7520101", name: "Cơ kỹ thuật" },
	{ code: "7520103", name: "Kỹ thuật cơ khí" },
	{ code: "7520114", name: "Kỹ thuật cơ điện tử" },
	{ code: "7520115", name: "Kỹ thuật nhiệt" },
	{ code: "7520116", name: "Kỹ thuật cơ khí động lực" },
	{ code: "7520117", name: "Kỹ thuật công nghiệp" },
	{ code: "7520118", name: "Kỹ thuật hệ thống công nghiệp" },
	{ code: "7520120", name: "Kỹ thuật hàng không" },
	{ code: "7520121", name: "Kỹ thuật không gian" },
	{ code: "7520122", name: "Kỹ thuật tàu thuỷ" },
	{ code: "7520130", name: "Kỹ thuật ô tô" },
	{ code: "7520137", name: "Kỹ thuật in" },
	{ code: "75202", name: "Kỹ thuật điện, điện tử và viễn thông" },
	{ code: "7520201", name: "Kỹ thuật điện" },
	{ code: "7520204", name: "Kỹ thuật ra đa- dẫn đường" },
	{ code: "7520205", name: "Kỹ thuật thuỷ âm" },
	{ code: "7520207", name: "Kỹ thuật điện tử -viễn thông" },
	{ code: "7520212", name: "Kỹ thuật y sinh" },
	{ code: "7520216", name: "Kỹ thuật điều khiển và tự động hoá" },
	{ code: "75203", name: "Kỹ thuật hoá học, vật liệu, luyện kim và môi trường" },
	{ code: "7520301", name: "Kỹ thuật hoá học" },
	{ code: "7520309", name: "Kỹ thuật vật liệu" },
	{ code: "7520310", name: "Kỹ thuật vật liệu kim loại" },
	{ code: "7520312", name: "Kỹ thuật dệt" },
	{ code: "7520320", name: "Kỹ thuật môi trường" },
	{ code: "75204", name: "Vật lý kỹ thuật" },
	{ code: "7520401", name: "Vật lý kỹ thuật" },
	{ code: "7520402", name: "Kỹ thuật hạt nhân" },
	{ code: "75205", name: "Kỹ thuật địa chất, địa vật lý và trắc địa" },
	{ code: "7520501", name: "Kỹ thuật địa chất" },
	{ code: "7520502", name: "Kỹ thuật địa vật lý" },
	{ code: "7520503", name: "Kỹ thuật trắc địa - bản đồ" },
	{ code: "75206", name: "Kỹ thuật mỏ" },
	{ code: "7520601", name: "Kỹ thuật mỏ" },
	{ code: "7520602", name: "Kỹ thuật thăm dò và khảo sát" },
	{ code: "7520604", name: "Kỹ thuật dầu khí" },
	{ code: "7520607", name: "Kỹ thuật tuyển khoáng" },
	{ code: "75290", name: "Khác" },
	{ code: "7529001", name: "Kỹ thuật biển" },
	{ code: "754", name: "Sản xuất và chế biến" },
	{ code: "75401", name: "Chế biến lương thực, thực phẩm và đồ uống" },
	{ code: "7540101", name: "Công nghệ thực phẩm" },
	{ code: "7540102", name: "Kỹ thuật thực phẩm" },
	{ code: "7540104", name: "Công nghệ sau thu hoạch" },
	{ code: "7540105", name: "Công nghệ chế biến thuỷ sản" },
	{ code: "7540106", name: "Đảm bảo chất lượng và an toàn thực phẩm" },
	{ code: "75402", name: "Sản xuất, chế biến sợi, vải, giày, da" },
	{ code: "7540202", name: "Công nghệ sợi, dệt" },
	{ code: "7540203", name: "Công nghệ vật liệu dệt, may" },
	{ code: "7540204", name: "Công nghệ dệt, may" },
	{ code: "7540206", name: "Công nghệ da giày" },
	{ code: "75490", name: "Khác" },
	{ code: "7549001", name: "Công nghệ chế biến lâm sản" },
	{ code: "758", name: "Kiến trúc và xây dựng" },
	{ code: "75801", name: "Kiến trúc và quy hoạch" },
	{ code: "7580101", name: "Kiến trúc" },
	{ code: "7580102", name: "Kiến trúc cảnh quan" },
	{ code: "7580103", name: "Kiến trúc nội thất" },
	{ code: "7580104", name: "Kiến trúc đô thị" },
	{ code: "7580105", name: "Quy hoạch vùng và đô thị" },
	{ code: "7580106", name: "Quản lý đô thị và công trình" },
	{ code: "7580108", name: "Thiết kế nội thất" },
	{ code: "7580111", name: "Bảo tồn di sản kiến trúc - đô thị" },
	{ code: "7580112", name: "Đô thị học" },
	{ code: "75802", name: "Xây dựng" },
	{ code: "7580201", name: "Kỹ thuật xây dựng" },
	{ code: "7580202", name: "Kỹ thuật xây dựng công trình thuỷ" },
	{ code: "7580203", name: "Kỹ thuật xây dựng công trình biển" },
	{ code: "7580205", name: "Kỹ thuật xây dựng công trình giao thông" },
	{ code: "7580210", name: "Kỹ thuật cơ sở hạ tầng" },
	{ code: "7580211", name: "Địa kỹ thuật xây dựng" },
	{ code: "7580212", name: "Kỹ thuật tài nguyên nước" },
	{ code: "7580213", name: "Kỹ thuật cấp thoát nước" },
	{ code: "75803", name: "Quản lý xây dựng" },
	{ code: "7580301", name: "Kinh tế xây dựng" },
	{ code: "7580302", name: "Quản lý xây dựng" },
	{ code: "75890", name: "Khác" },
	{ code: "762", name: "Nông, lâm nghiệp và thuỷ sản" },
	{ code: "76201", name: "Nông nghiệp" },
	{ code: "7620101", name: "Nông nghiệp" },
	{ code: "7620102", name: "Khuyến nông" },
	{ code: "7620103", name: "Khoa học đất" },
	{ code: "7620105", name: "Chăn nuôi" },
	{ code: "7620109", name: "Nông học" },
	{ code: "7620110", name: "Khoa học cây trồng" },
	{ code: "7620112", name: "Bảo vệ thực vật" },
	{ code: "7620113", name: "Công nghệ rau hoa quả và cảnh quan" },
	{ code: "7620114", name: "Kinh doanh nông nghiệp" },
	{ code: "7620115", name: "Kinh tế nông nghiệp" },
	{ code: "7620116", name: "Phát triển nông thôn" },
	{ code: "76202", name: "Lâm nghiệp" },
	{ code: "7620201", name: "Lâm học" },
	{ code: "7620202", name: "Lâm nghiệp đô thị" },
	{ code: "7620205", name: "Lâm sinh" },
	{ code: "7620211", name: "Quản lý tài nguyên rừng" },
	{ code: "76203", name: "Thuỷ sản" },
	{ code: "7620301", name: "Nuôi trồng thuỷ sản" },
	{ code: "7620302", name: "Bệnh học thủy sản" },
	{ code: "7620303", name: "Khoa học thủy sản" },
	{ code: "7620304", name: "Khai thác thuỷ sản" },
	{ code: "7620305", name: "Quản lý thủy sản" },
	{ code: "76290", name: "Khác" },
	{ code: "764", name: "Thú y" },
	{ code: "76401", name: "Thú y" },
	{ code: "7640101", name: "Thú y" },
	{ code: "76490", name: "Khác" },
	{ code: "772", name: "Sức khoẻ" },
	{ code: "77201", name: "Y học" },
	{ code: "7720101", name: "Y khoa" },
	{ code: "7720110", name: "Y học dự phòng" },
	{ code: "7720115", name: "Y học cổ truyền" },
	{ code: "77202", name: "Dược học" },
	{ code: "7720201", name: "Dược học" },
	{ code: "7720203", name: "Hoá dược" },
	{ code: "77203", name: "Điều dưỡng - hộ sinh" },
	{ code: "7720301", name: "Điều dưỡng" },
	{ code: "7720302", name: "Hộ sinh" },
	{ code: "77204", name: "Dinh dưỡng" },
	{ code: "7720401", name: "Dinh dưỡng" },
	{ code: "77205", name: "Răng - Hàm - Mặt (Nha khoa)" },
	{ code: "7720501", name: "Răng - Hàm - Mặt" },
	{ code: "7720502", name: "Kỹ thuật phục hình răng" },
	{ code: "77206", name: "Kỹ thuật Y học" },
	{ code: "7720601", name: "Kỹ thuật xét nghiệm y học" },
	{ code: "7720602", name: "Kỹ thuật hình ảnh y học" },
	{ code: "7720603", name: "Kỹ thuật phục hồi chức năng" },
	{ code: "77207", name: "Y tế công cộng" },
	{ code: "7720701", name: "Y tế công cộng" },
	{ code: "77208", name: "Quản lý Y tế" },
	{ code: "7720801", name: "Tổ chức và quản lý y tế" },
	{ code: "7720802", name: "Quản lý bệnh viện" },
	{ code: "77290", name: "Khác" },
	{ code: "7729001", name: "Y sinh học thể dục thể thao" },
	{ code: "776", name: "Dịch vụ xã hội" },
	{ code: "77601", name: "Công tác xã hội" },
	{ code: "7760101", name: "Công tác xã hội" },
	{ code: "7760102", name: "Công tác thanh thiếu niên" },
	{ code: "8760103", name: "Hỗ trợ giáo dục người khuyết tật" },
	{ code: "77690", name: "Khác" },
	{ code: "781", name: "Du lịch, khách sạn, thể thao và dịch vụ cá nhân" },
	{ code: "78101", name: "Du lịch" },
	{ code: "7810101", name: "Du lịch" },
	{ code: "7810103", name: "Quản trị dịch vụ du lịch và lữ hành" },
	{ code: "78102", name: "Khách sạn, nhà hàng" },
	{ code: "7810201", name: "Quản trị khách sạn" },
	{ code: "7810202", name: "Quản trị nhà hàng và dịch vụ ăn uống" },
	{ code: "78103", name: "Thể dục, thể thao" },
	{ code: "7810301", name: "Quản lý thể dục thể thao" },
	{ code: "78105", name: "Kinh tế gia đình" },
	{ code: "7810501", name: "Kinh tế gia đình" },
	{ code: "78190", name: "Khác" },
	{ code: "784", name: "Dịch vụ vận tải" },
	{ code: "78401", name: "Khai thác vận tải" },
	{ code: "7840101", name: "Khai thác vận tải" },
	{ code: "7840102", name: "Quản lý hoạt động bay" },
	{ code: "7840104", name: "Kinh tế vận tải" },
	{ code: "7840106", name: "Khoa học hàng hải" },
	{ code: "78490", name: "Khác" },
	{ code: "785", name: "Môi trường và bảo vệ môi trường" },
	{ code: "78501", name: "Quản lý tài nguyên và môi trường" },
	{ code: "7850101", name: "Quản lý tài nguyên và môi trường" },
	{ code: "7850102", name: "Kinh tế tài nguyên thiên nhiên" },
	{ code: "7850103", name: "Quản lý đất đai" },
	{ code: "78502", name: "Dịch vụ an toàn lao động và vệ sinh công nghiệp" },
	{ code: "7850201", name: "Bảo hộ lao động" },
	{ code: "78590", name: "Khác" },
	{ code: "786", name: "An ninh, Quốc phòng" },
	{ code: "78601", name: "An ninh và trật tự xã hội" },
	{ code: "7860101", name: "Trinh sát an ninh" },
	{ code: "7860102", name: "Trinh sát cảnh sát" },
	{ code: "7860104", name: "Điều tra hình sự" },
	{ code: "7860108", name: "Kỹ thuật hình sự" },
	{ code: "7860109", name: "Quản lý nhà nước về an ninh trật tự" },
	{ code: "7860110", name: "Quản lý trật tự an toàn giao thông" },
	{ code: "7860111", name: "Thi hành án hình sự và hỗ trợ tư pháp" },
	{ code: "7860112", name: "Tham mưu, chỉ huy công an nhân dân" },
	{ code: "7860113", name: "Phòng cháy chữa cháy và cứu nạn cứu hộ" },
	{ code: "7860116", name: "Hậu cần công an nhân dân" },
	{ code: "7860117", name: "Tình báo an ninh" },
	{ code: "78602", name: "Quân sự" },
	{ code: "7860201", name: "Chỉ huy tham mưu Lục quân" },
	{ code: "7860202", name: "Chỉ huy tham mưu Hải quân" },
	{ code: "7860203", name: "Chỉ huy tham mưu Không quân" },
	{ code: "7860204", name: "Chỉ huy tham mưu Phòng không" },
	{ code: "7860205", name: "Chỉ huy tham mưu Pháo binh" },
	{ code: "7860206", name: "Chỉ huy tham mưu Tăng - thiết giáp" },
	{ code: "7860207", name: "Chỉ huy tham mưu Đặc công" },
	{ code: "7860214", name: "Biên phòng" },
	{ code: "7860217", name: "Tình báo quân sự" },
	{ code: "7860218", name: "Hậu cần quân sự" },
	// { "7860220": "Chỉ huy tham mưu thông tin"},
	{ code: "7860222", name: "Quân sự cơ sở" },
	{ code: "7860220", name: "Chỉ huy, quản lý kỹ thuật" },
	{ code: "7860226", name: "Chỉ huy kỹ thuật Phòng không" },
	{ code: "7860227", name: "Chỉ huy kỹ thuật Tăng - thiết giáp" },
	{ code: "7860228", name: "Chỉ huy kỹ thuật Công binh" },
	{ code: "7860229", name: "Chỉ huy kỹ thuật Hoá học" },
	{ code: "7860231", name: "Trinh sát kỹ thuật" },
	{ code: "7860232", name: "Chỉ huy kỹ thuật Hải quân" },
	{ code: "7860233", name: "Chỉ huy kỹ thuật tác chiến điện tử" },
	{ code: "78690", name: "Khác" },
	{ code: "790", name: "Khác" },
];

export const classificationList = [
	{ code: "1", name: "Xuất sắc" },
	{ code: "2", name: "Giỏi" },
	{ code: "3", name: "Khá" },
	{ code: "4", name: "Trung bình" },
	{ code: "5", name: "Yếu" },
	{ code: "6", name: "Kém" },
	{ code: "7", name: "Trung bình khá" },
];

export const languageLevelOptions = [
	{ value: "Bậc 3", label: "Bậc 3" },
	{ value: "Bậc 4", label: "Bậc 4" },
	{ value: "Bậc 5", label: "Bậc 5" },
];

export const classificationScholarship = [
	{ code: "Đạt danh hiệu Sinh viên Xuất sắc", name: "Đạt danh hiệu Sinh viên Xuất sắc" },
	{ code: "Đạt danh hiệu Sinh viên Giỏi", name: "Đạt danh hiệu Sinh viên Giỏi" },
	{ code: "Đạt danh hiệu Sinh viên Tiên tiến", name: "Đạt danh hiệu Sinh viên Tiên tiến" },
];

export const requestTypeList = [
	{ code: "1", name: "Cấp mới" },
	{ code: "2", name: "Chỉnh sửa" },
	{ code: "3", name: "Huỷ bằng" },
];

export const trainingMethodList = [
	{ code: "Chính quy", name: "Chính quy" },
	{ code: "Liên thông", name: "Liên thông" },
	{ code: "Từ xa", name: "Từ xa" },
	{ code: "Tại chức", name: "Tại chức" },
	{ code: "Khác", name: "Khác" },
];
export const statusList = [
	{ code: "Nội bộ", name: "Nội bộ" },
	{ code: "Đang gửi", name: "Đang gửi" },
	{ code: "Đã xác nhận", name: "Đã xác nhận" },
	{ code: "Đã thu hồi", name: "Đã thu hồi" },
];

export const ethnicCodeAndNameList = [
	{ code: "1", name: "Kinh (Việt)" },
	{ code: "2", name: "Tày" },
	{ code: "3", name: "Thái" },
	{ code: "4", name: "Mường " },
	{ code: "5", name: "Khmer" },
	{ code: "6", name: "Hoa " },
	{ code: "7", name: "Nùng  " },
	{ code: "8", name: "Mông" },
	{ code: "9", name: "Dao" },
	{ code: "10", name: "Gia Rai" },
	{ code: "11", name: "Ê  Đê" },
	{ code: "12", name: "Ba Na" },
	{ code: "13", name: "Sán Chay " },
	{ code: "14", name: "Chăm " },
	{ code: "15", name: "Cơ Ho" },
	{ code: "16", name: "Xơ Đăng" },
	{ code: "17", name: "Sán Dìu" },
	{ code: "18", name: "Hrê" },
	{ code: "19", name: "RaGlay" },
	{ code: "20", name: "Mnông" },
	{ code: "21", name: "Thổ (4)" },
	{ code: "22", name: "Xtiêng" },
	{ code: "23", name: "Khơ mú" },
	{ code: "24", name: "Bru Vân Kiều" },
	{ code: "25", name: "Cơ Tu" },
	{ code: "26", name: "Giáy" },
	{ code: "27", name: "Tà Ôi" },
	{ code: "28", name: "Mạ" },
	{ code: "29", name: "Giẻ-Triêng" },
	{ code: "30", name: "Co" },
	{ code: "31", name: "Chơ Ro" },
	{ code: "32", name: "Xinh Mun" },
	{ code: "33", name: "Hà Nhì" },
	{ code: "34", name: "Chu Ru" },
	{ code: "35", name: "Lào" },
	{ code: "36", name: "La Chí" },
	{ code: "37", name: "Kháng" },
	{ code: "38", name: "Phù Lá" },
	{ code: "39", name: "La Hủ" },
	{ code: "40", name: "La Ha" },
	{ code: "41", name: "Pà Thẻn" },
	{ code: "42", name: "Lự" },
	{ code: "43", name: "Ngái" },
	{ code: "44", name: "Chứt" },
	{ code: "45", name: "Lô Lô" },
	{ code: "46", name: "Mảng" },
	{ code: "47", name: "Cơ Lao" },
	{ code: "48", name: "Bố Y" },
	{ code: "49", name: "Cống" },
	{ code: "50", name: "Si La" },
	{ code: "51", name: "Pu Péo" },
	{ code: "52", name: "Rơ Măm" },
	{ code: "53", name: "Brâu" },
	{ code: "54", name: "Ơ Đu" },
	{ code: "56", name: "Dân tộc khác" },
];

export const nationalityCodeAndNameList = [
	{ code: "1", name: "Afghanistan" },
	{ code: "2", name: "Åland Islands" },
	{ code: "3", name: "Albania" },
	{ code: "4", name: "Algérie (An-giê-ri)" },
	{ code: "5", name: "American Samoa" },
	{ code: "6", name: "Andorra (An-đô-ra)" },
	{ code: "7", name: "Angola (Ăng-gô-la)" },
	{ code: "8", name: "Anguilla" },
	{ code: "9", name: "Antarctica" },
	{ code: "10", name: "Antigua và Barbuda (An-ti-goa và Bác-bu-da)" },
	{ code: "11", name: "Argentina" },
	{ code: "12", name: "Armenia (Ác-mê-ni-a)" },
	{ code: "13", name: "Aruba" },
	{ code: "14", name: "Úc (Ốt-xrây-li-a)" },
	{ code: "15", name: "Áo" },
	{ code: "16", name: "Azerbaijan (A-giéc-bai-gian)" },
	{ code: "17", name: "Bahamas (Ba-ha-mát)" },
	{ code: "18", name: "Bahrain (Ba-ranh)" },
	{ code: "19", name: "Bangladesh (Băng-la-đét)" },
	{ code: "20", name: "Barbados (Bác-ba-đốt)" },
	{ code: "21", name: "Belarus (Bê-la-rút)" },
	{ code: "22", name: "Bỉ" },
	{ code: "23", name: "Belize (Bê-li-xê)" },
	{ code: "24", name: "Benin (Bê-nanh)" },
	{ code: "25", name: "Bermuda" },
	{ code: "26", name: "Bhutan (Bu-tan)" },
	{ code: "27", name: "Bolivia (Bô-li-vi-a)" },
	{ code: "28", name: "Bosna và Hercegovina (Bốt-xni-a và Héc-dê-gô-vi-na)" },
	{ code: "29", name: "Botswana" },
	{ code: "30", name: "Bouvet Island" },
	{ code: "31", name: "Brasil (Bra-xin)" },
	{ code: "32", name: "British Indian Ocean Territory" },
	{ code: "33", name: "Brunei (Bru-nây)" },
	{ code: "34", name: "Bulgaria (Bungari)" },
	{ code: "35", name: "Burkina Faso (Buốc-ki-na Pha-xô)" },
	{ code: "36", name: "Burundi" },
	{ code: "37", name: "Campuchia" },
	{ code: "38", name: "Cameroon (Ca-mơ-run)" },
	{ code: "39", name: "Canada (Ca-na-đa; Gia Nã Đại)" },
	{ code: "40", name: "Cabo Verde (Cáp Ve)" },
	{ code: "41", name: "Cayman Islands" },
	{ code: "42", name: "Trung Phi" },
	{ code: "43", name: "Tchad (Sát)" },
	{ code: "44", name: "Chile (Chi-lê)" },
	{ code: "45", name: "Trung Quốc" },
	{ code: "46", name: "Christmas Island" },
	{ code: "47", name: "Cocos (Keeling) Islands" },
	{ code: "48", name: "Colombia (Cô-lôm-bi-a)" },
	{ code: "49", name: "Comoros (Cô-mo)" },
	{ code: "50", name: "Cộng hòa Congo (Công-gô; Congo-Brazzaville)" },
	{ code: "51", name: "Cộng hòa Dân chủ Congo (Congo-Kinshasa)" },
	{ code: "52", name: "Cook Islands" },
	{ code: "53", name: "Costa Rica (Cốt-xta Ri-ca)" },
	{ code: "54", name: "Bờ Biển Ngà (Cốt-đi-voa)" },
	{ code: "55", name: "Croatia (Crô-a-ti-a)" },
	{ code: "56", name: "Cuba (Cu-ba)" },
	{ code: "57", name: "Síp" },
	{ code: "58", name: "Séc (Tiệp)" },
	{ code: "59", name: "Đan Mạch" },
	{ code: "60", name: "Djibouti (Gi-bu-ti)" },
	{ code: "61", name: "Dominica (Đô-mi-ni-ca)" },
	{ code: "62", name: "Cộng hòa Dominicana (Đô-mi-ni-ca-na)" },
	{ code: "63", name: "Ecuador (Ê-cu-a-đo)" },
	{ code: "64", name: "Ai Cập" },
	{ code: "65", name: "El Salvador (En Xan-va-đo)" },
	{ code: "66", name: "Guinea Xích Đạo (Ghi-nê Xích Đạo)" },
	{ code: "67", name: "Eritrea (Ê-ri-tơ-ri-a)" },
	{ code: "68", name: "Estonia (E-xtô-ni-a)" },
	{ code: "69", name: "Ethiopia (Ê-t(h)i-ô-pi-a)" },
	{ code: "70", name: "Falkland Islands (Malvinas)" },
	{ code: "71", name: "Faroe Islands" },
	{ code: "72", name: "Fiji (Phi-gi)" },
	{ code: "73", name: "Phần Lan" },
	{ code: "74", name: "Pháp (Pháp Lan Tây)" },
	{ code: "75", name: "French Guiana" },
	{ code: "76", name: "French Polynesia" },
	{ code: "77", name: "French Southern Territories" },
	{ code: "78", name: "Gabon (Ga-bông)" },
	{ code: "79", name: "Gambia (Găm-bi-a)" },
	{ code: "80", name: "Gruzia (Gru-di-a)" },
	{ code: "81", name: "Đức" },
	{ code: "82", name: "Ghana (Ga-na)" },
	{ code: "83", name: "Gibraltar" },
	{ code: "84", name: "Hy Lạp" },
	{ code: "85", name: "Greenland" },
	{ code: "86", name: "Grenada (Grê-na-đa)" },
	{ code: "87", name: "Guadeloupe" },
	{ code: "88", name: "Guam" },
	{ code: "89", name: "Guatemala (Goa-tê-ma-la)" },
	{ code: "90", name: "Guinea (Ghi-nê)" },
	{ code: "91", name: "Guinea-Bissau (Ghi-nê Bít-xao)" },
	{ code: "92", name: "Guyana (Gai-a-na)" },
	{ code: "93", name: "Haiti (Ha-i-ti)" },
	{ code: "94", name: "Heard Island And Mcdonald Islands" },
	{ code: "95", name: "Holy See (Vatican City State)" },
	{ code: "96", name: "Honduras (Hôn-đu-rát) (Ôn-đu-rát)" },
	{ code: "97", name: "Hong Kong" },
	{ code: "98", name: "Hungary (Hung-ga-ri)" },
	{ code: "99", name: "Iceland (Ai xơ len)" },
	{ code: "100", name: "Cộng hòa Ấn Độ" },
	{ code: "101", name: "Indonesia (In-đô-nê-xi-a)" },
	{ code: "102", name: "Iran" },
	{ code: "103", name: "Iraq (I-rắc)" },
	{ code: "104", name: "Ireland (Ai-len)" },
	{ code: "105", name: "Israel (I-xra-en)" },
	{ code: "106", name: "Ý (I-ta-li-a)" },
	{ code: "107", name: "Jamaica (Gia-mai-ca)" },
	{ code: "108", name: "Nhật Bản" },
	{ code: "109", name: "Jordan (Gioóc-đan-ni)" },
	{ code: "110", name: "Kazakhstan (Ca-dắc-xtan)" },
	{ code: "111", name: "Kenya (Kê-nhi-a)" },
	{ code: "112", name: "Kiribati" },
	{ code: "113", name: "Triều Tiên" },
	{ code: "114", name: "Hàn Quốc (Nam Hàn)" },
	{ code: "115", name: "Kuwait (Cô-oét)" },
	{ code: "116", name: "Kyrgyzstan (Cư-rơ-gư-xtan)" },
	{ code: "117", name: "Lào" },
	{ code: "118", name: "Latvia (Lat-vi-a)" },
	{ code: "119", name: "Li ban (Li-băng)" },
	{ code: "120", name: "Lesotho (Lê-xô-thô)" },
	{ code: "121", name: "Liberia (Li-bê-ri-a)" },
	{ code: "122", name: "Libya (Li-bi)" },
	{ code: "123", name: "Liechtenstein (Lích-ten-xtai)" },
	{ code: "124", name: "Litva (Lít-va)" },
	{ code: "125", name: "Luxembourg (Lúc-xem-bua)" },
	{ code: "126", name: "Macao" },
	{ code: "127", name: "Macedonia (Mã Cơ Đốn) (Ma-xê-đô-ni-a)" },
	{ code: "128", name: "Madagascar" },
	{ code: "129", name: "Malawi (Ma-la-uy)" },
	{ code: "130", name: "Malaysia (Mã Lai Tây Á)(Ma-lay-xi-a)" },
	{ code: "131", name: "Maldives (Man-di-vơ)" },
	{ code: "132", name: "Mali" },
	{ code: "133", name: "Malta (Man-ta)" },
	{ code: "134", name: "Quần đảo Marshall" },
	{ code: "135", name: "Martinique" },
	{ code: "136", name: "Mauritanie (Mô-ri-ta-ni)" },
	{ code: "137", name: "Mauritius (Mô-ri-xơ)" },
	{ code: "138", name: "Mayotte" },
	{ code: "139", name: "Mexico (Mê-hi-cô)" },
	{ code: "140", name: "Micronesia (Mi-crô-nê-di)" },
	{ code: "141", name: "Moldova (Môn-đô-va)" },
	{ code: "142", name: "Monaco (Mô-na-cô)" },
	{ code: "143", name: "Mông Cổ" },
	{ code: "144", name: "Montserrat" },
	{ code: "145", name: "Maroc" },
	{ code: "146", name: "Mozambique (Mô-dăm-bích)" },
	{ code: "147", name: "Myanma (Mi-an-ma)" },
	{ code: "148", name: "Namibia (Na-mi-bi-a)" },
	{ code: "149", name: "Nauru (Nau-ru)" },
	{ code: "150", name: "Nepal (Nê-pan)" },
	{ code: "151", name: "Hà Lan (Hòa Lan)" },
	{ code: "152", name: "Netherlands Antilles" },
	{ code: "153", name: "New Caledonia" },
	{ code: "154", name: "New Zealand (Niu Di-lân) (Tân Tây Lan)" },
	{ code: "155", name: "Nicaragua (Ni-ca-ra-goa)" },
	{ code: "156", name: "Niger (Ni-giê)" },
	{ code: "157", name: "Nigeria (Ni-giê-ri-a)" },
	{ code: "158", name: "Niue" },
	{ code: "159", name: "Norfolk Island" },
	{ code: "160", name: "Northern Mariana Islands" },
	{ code: "161", name: "Na Uy" },
	{ code: "162", name: "Oman (Ô-man)" },
	{ code: "163", name: "Pakistan (Pa-kít-xtan)" },
	{ code: "164", name: "Palau (Pa-lau)" },
	{ code: "165", name: "Palestinian Territory, Occupied" },
	{ code: "166", name: "Panama (Pa-na-ma)" },
	{ code: "167", name: "Papua New Guinea (Pa-pua Niu Ghi-nê)" },
	{ code: "168", name: "Paraguay (Pa-ra-goay)" },
	{ code: "169", name: "Peru (Pê-ru)" },
	{ code: "170", name: "Philippines (Phi-líp-pin)" },
	{ code: "171", name: "Pitcairn" },
	{ code: "172", name: "Ba Lan" },
	{ code: "173", name: "Bồ Đào Nha" },
	{ code: "174", name: "Puerto Rico" },
	{ code: "175", name: "Qatar (Ca-ta)" },
	{ code: "176", name: "Réunion" },
	{ code: "177", name: "Romania (Ru-ma-ni, Lỗ Ma Ni)" },
	{ code: "178", name: "Nga" },
	{ code: "179", name: "Rwanda (Ru-an-đa)" },
	{ code: "180", name: "Saint Helena" },
	{ code: "181", name: "Saint Kitts và Nevis (Xanh Kít và Nê-vít)" },
	{ code: "182", name: "Saint Lucia (San-ta Lu-xi-a)" },
	{ code: "183", name: "Saint Pierre And Miquelon" },
	{ code: "184", name: "Saint Vincent và Grenadines (Xanh Vin-xen và Grê-na-din)" },
	{ code: "185", name: "Samoa (Xa-moa)" },
	{ code: "186", name: "San Marino (San Ma-ri-nô)" },
	{ code: "187", name: "São Tomé và Príncipe (Sao Tô-mê và Prin-xi-pê)" },
	{ code: "188", name: "Ả Rập Saudi (Ả Rập Xê-út)" },
	{ code: "189", name: "Sénégal (Xê-nê-gan)" },
	{ code: "190", name: "Serbia (Xéc-bi-a)" },
	{ code: "191", name: "Seychelles (Xây-sen)" },
	{ code: "192", name: "Sierra Leone (Xi-ê-ra Lê-ôn)" },
	{ code: "193", name: "Singapore (Xinh-ga-po)" },
	{ code: "194", name: "Slovakia (Xlô-va-ki-a)" },
	{ code: "195", name: "Slovenia (Xlô-ven-ni-a)" },
	{ code: "196", name: "Solomon (Xô-lô-môn)" },
	{ code: "197", name: "Somalia (Xô-ma-li)" },
	{ code: "198", name: "Nam Phi" },
	{ code: "199", name: "South Georgia And The South Sandwich Islands" },
	{ code: "200", name: "Tây Ban Nha" },
	{ code: "201", name: "Sri Lanka (Xri Lan-ca)" },
	{ code: "202", name: "Sudan (Xu-đăng)" },
	{ code: "203", name: "Suriname (Xu-ri-nam)" },
	{ code: "204", name: "Svalbard And Jan Mayen" },
	{ code: "205", name: "Swaziland (Xoa-di-len)" },
	{ code: "206", name: "Thụy Điển" },
	{ code: "207", name: "Thụy Sĩ (Thụy Sỹ)" },
	{ code: "208", name: "Syria (Xi-ri)" },
	{ code: "209", name: "Taiwan, Province Of China" },
	{ code: "210", name: "Tajikistan (Tát-gi-kít-xtan)" },
	{ code: "211", name: "Tanzania (Tan-da-ni-a)" },
	{ code: "212", name: "Thái Lan" },
	{ code: "213", name: "Đông Timor (Ti-mo Lex-te)" },
	{ code: "214", name: "Togo (Tô-gô)" },
	{ code: "215", name: "Tokelau" },
	{ code: "216", name: "Tonga (Tông-ga)" },
	{ code: "217", name: "Trinidad và Tobago (Tri-ni-đát và Tô-ba-gô)" },
	{ code: "218", name: "Tunisia (Tuy-ni-di)" },
	{ code: "219", name: "Thổ Nhĩ Kỳ" },
	{ code: "220", name: "Turkmenistan (Tuốc-mê-ni-xtan)" },
	{ code: "221", name: "Turks And Caicos Islands" },
	{ code: "222", name: "Tuvalu" },
	{ code: "223", name: "Uganda (U-gan-đa)" },
	{ code: "224", name: "Ukraina (U-crai-na)" },
	{ code: "225", name: "Các Tiểu Vương quốc Ả Rập Thống nhất" },
	{ code: "226", name: "Vương quốc Liên hiệp Anh và Bắc Ireland" },
	{ code: "227", name: "Hoa Kỳ (Mỹ)" },
	{ code: "228", name: "United States Minor Outlying Islands" },
	{ code: "229", name: "Uruguay (U-ru-goay)" },
	{ code: "230", name: "Uzbekistan (U-dơ-bê-kít-xtan)" },
	{ code: "231", name: "Vanuatu (Va-nu-a-tu)" },
	{ code: "232", name: "Thành Vatican (Va-ti-căng)/Tòa Thánh" },
	{ code: "233", name: "Venezuela (Vê-nê-xu(y)-ê-la)" },
	{ code: "234", name: "Việt Nam" },
	{ code: "235", name: "Virgin Islands, British" },
	{ code: "236", name: "Virgin Islands, U.S." },
	{ code: "237", name: "Wallis And Futuna" },
	{ code: "238", name: "Western Sahara" },
	{ code: "239", name: "Yemen (Y-ê-men)" },
	{ code: "240", name: "Zambia (Dăm-bi-a)" },
	{ code: "241", name: "Zimbabwe (Dim-ba-bu-ê)" },
	{ code: "242", name: "Cộng hòa Azerbaijan" },
	{ code: "243", name: "Cộng hòa Croatia" },
	{ code: "244", name: "Montenegro (Môn-tê-nê-grô)" },
	{ code: "245", name: "Nam Sudan" },
];


export const majorListForScholarship = [
	"Công nghệ thông tin",
	"Công nghệ tài chính",
	"Ngôn ngữ Hàn Quốc",
	"Thiết kế công nghiệp",
	"Văn học",
	"Marketing",
	"Du lịch",
	"Công nghệ sinh học",
	"Luật",
	"Diễn viên kịch, điện ảnh - truyền hình",
	"Tâm lý học",
	"Răng - Hàm - Mặt",
	"Kinh doanh quốc tế",
	"Công nghệ kỹ thuật ô tô",
	"Dược học",
	"Đạo diễn điện ảnh, truyền hình",
	"Kỹ thuật nhiệt",
	"Kỹ thuật xét nghiệm y học",
	"Nông nghiệp công nghệ cao",
	"Kế toán",
	"Kỹ thuật phần mềm",
	"Kinh tế quốc tế",
	"Y khoa",
	"Đông phương học",
	"Quản lý xây dựng",
	"Kỹ thuật hàng không",
	"Thanh nhạc",
	"Công nghệ thẩm mỹ",
	"Quản trị nhà hàng và dịch vụ ăn uống",
	"Quản trị dịch vụ du lịch và lữ hành",
	"Quản trị môi trường doanh nghiệp",
	"Quan hệ công chúng",
	"Ngôn ngữ Anh",
	"Công nghệ truyền thông",
	"Quản trị khách sạn",
	"Kiến trúc",
	"Thương mại điện tử",
	"Công nghệ kỹ thuật điện, điện tử",
	"Hệ thống thông tin",
	"Thiết kế nội thất",
	"Công nghệ sinh học y dược",
	"Kỹ thuật cơ điện tử",
	"Điều dưỡng",
	"Kinh doanh thương mại",
	"Quản trị kinh doanh",
	"Công nghệ điện ảnh, truyền hình",
	"Hệ thống thông tin quản lý",
	"Mạng máy tính và truyền thông dữ liệu",
	"Công nghệ kỹ thuật môi trường",
	"Piano",
	"Logistics và quản lý chuỗi cung ứng",
	"Tài chính - Ngân hàng",
	"Ngôn ngữ Trung Quốc",
	"Thiết kế đồ họa",
	"Luật kinh tế",
	"Kỹ thuật xây dựng",
	"Thiết kế mỹ thuật số",
	"Truyền thông đa phương tiện",
	"Khoa học dữ liệu",
	"Bất động sản",
	"Công nghệ thực phẩm",
	"Thiết kế thời trang",
]